import { render, staticRenderFns } from "./ReportCollapsible.vue?vue&type=template&id=4ad21790&scoped=true"
import script from "./ReportCollapsible.vue?vue&type=script&lang=js"
export * from "./ReportCollapsible.vue?vue&type=script&lang=js"
import style0 from "./ReportCollapsible.vue?vue&type=style&index=0&id=4ad21790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad21790",
  null
  
)

export default component.exports